import { Resource } from '@teem/generic/resource';
import { Serializer } from '@teem/generic/serializer';
import { ProductAddon } from '@teem/models/product-addon';

export class ProductSerializer implements Serializer {
  fromJson(json: any): Product {
    let productService = new Product(json);
    return productService;
  }

  toJson(product: Product): any {
    return product;
  }
}

export class Product implements Resource {

  public uuid: string;
  public store_id: number;
  public category_id: number;
  public product_number: number;
  public name: string;
  public name_ar: string;
  public description: string;
  public description_ar: string;
  public quantity: number;
  public price: number;
  public discount_percent: number;
  public preparation_time: number;
  public net_price: number;
  public product_image: string;
  public active: number = 1;
  public weight: number;
  public calories: number;
  public proteins: number;
  public carbs: number;
  public add_ons: ProductAddon[];
  public inactive_branch: Array<any> = [];

  constructor(input?: any) {

    if (input) {
      Object.assign(this, input);

      if(input.add_ons && input.add_ons.length){
				this.add_ons = [];
				input.add_ons.forEach(addon => {
					this.add_ons.push(new ProductAddon(addon))
				});
			}
    }
  }
}
